import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { PraxTestkitRegistrationRequestDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/testkit`;

export const registerTestkit = (
    request: Partial<PraxTestkitRegistrationRequestDto>,
    source: CancelTokenSource): Promise<string> => {

  return axios
      .post(`${apiUri}/register-testkit`, request, {cancelToken: source.token})
      .then(response => response.data)
};
